export const regexOnlyLetters = /^[A-Za-zÀ-ÖØ-öø-ÿ-~,-. '-(-)]+$/;

// (99) 99999999 || 999999999
export const regexPhoneNumber = /^(\()(\d{2})(\))[ ]?(\d{8}|\d{9})\s*$/;

export const regexHasNumber = /\d/;
